import { BadgeCheck } from 'lucide-react';

export const VerifiedBadge = ({ verified = false, className = '' }) => {
    if (!verified) return null;
    return (
        <span className={`inline-flex items-center gap-1 text-emerald-700 bg-emerald-50 border border-emerald-200 text-[10px] px-1.5 py-0.5 rounded-full font-semibold ${className}`} title="Vendedor verificado" data-testid="verified-badge">
            <BadgeCheck className="h-3 w-3" />Verificado
        </span>
    );
};
